module.exports = __webpack_public_path__ + "static/media/football-icon.c6cbaa17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football-icon.svg
// module id = 36
// module chunks = 0